import { h } from "preact";
import { RoutableProps } from "preact-router";
import { OrderCreator } from "../../../components/OrderCreator";
import "./styles.scss";

export function OrderEdit(props: RoutableProps & { id?: string }) {
    return <div class="order-edit-page">
        <OrderCreator id={props.id} orderTypes={[]} serialRegexes={[]}/>
    </div>;
}
